import { render, staticRenderFns } from "./OrganisationStructure.vue?vue&type=template&id=fbf7e9b0"
import script from "./OrganisationStructure.vue?vue&type=script&lang=js"
export * from "./OrganisationStructure.vue?vue&type=script&lang=js"
import style0 from "./OrganisationStructure.vue?vue&type=style&index=0&id=fbf7e9b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports